import axios from 'axios';
import apisUrls from '../urls';

const getAllPackagesApiCall = (paramsFilter) => {
  return axios.get(apisUrls?.getAppPackages(paramsFilter));
};

export default getAllPackagesApiCall;
